<template>
  <component :is="currentComponent">
    <section class="px-0 flex md:flex-row flex-col bg-gray-lightest mb-8">
      <section class="md:w-3/12 lg:w-3/12 md:mr-4 mt-4 p-6 h-100 rounded-lg shadow-lg">
        <section class="flex md:grid">
          <div
            class="flex justify-center mt-4 relative"
            @mouseover="isAdminView ? '' : isProfileOptionsOpen = true"
            @mouseleave="isAdminView ? '' : isProfileOptionsOpen = false"
          >
            <div v-if="thumbnail_url">
              <Avatar
                :classStr="'object-cover md:h-40 md:w-40 h-auto w-20'"
                :src="baseUrlSrc(thumbnail_url)"
              />
            </div>
            <div v-else>
              <Avatar
                :classStr="'md:h-40 md:w-40 h-auto w-20'"
                :src="baseUrlSrc('assets/images/default/default_profile.png')"
              />
            </div>
            <div class="absolute bottom-0" v-if="isProfileOptionsOpen">
              <div class="flex items-center">
                <div v-if="thumbnail_url">
                  <button
                    type="button"
                    class="text-black shadow-lg bg-gray-lightest rounded-full p-1 mb-2 mr-2"
                    @click.prevent="handleUserProfileRemoveDp"
                  >
                    <Trash />
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    class="text-black shadow-lg bg-gray-lightest rounded-full p-1 mb-2"
                    @click.prevent="
                      isProfileImageModalOpen = !isProfileImageModalOpen
                    "
                  >
                    <Pencil />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Modal
            v-model="isProfileImageModalOpen"
            :title="'Edit Profile Image'"
          >
            <div class="mb-2">
              <div v-if="thumbnailImagePreview">
                <Cropper
                  ref="cropper"
                  class="twitter-cropper"
                  background-class="twitter-cropper__background"
                  foreground-class="twitter-cropper__foreground"
                  image-restriction="stencil"
                  default-boundaries="fill"
                  :stencil-size="stencilSize"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: false,
                    aspectRatio: 1,
                    previewClass: 'twitter-cropper__stencil',
                  }"
                  :stencil-component="stencil"
                  :transitions="false"
                  :canvas="true"
                  :debounce="false"
                  :default-size="defaultSize"
                  :min-width="150"
                  :min-height="150"
                  :src="thumbnailImagePreview"
                  @change="onChange"
                />
                <Navigation :zoom="zoom" @change="onZoom" />
              </div>
              <div v-else class="flex justify-center p-4 bg-gray-100">
                <img
                  :src="baseUrlSrc(thumbnail_url)"
                  alt=""
                  class="object-cover rounded-full"
                  @error="defaultCircleImage"
                />
              </div>
              <span class="text-gray-dark">Upload Image</span>
              <input
                type="file"
                class="form-input mt-1 block w-full"
                @change="handleFileChange"
              />
            </div>
            <div class="mb-2 float-right">
              <button
                class="ring-green-dark ring-1 rounded py-1 px-4 mr-2 text-green-dark"
                @click="propfileUploadToggler"
              >
                Cancel
              </button>
              <button
                class="bg-green-dark text-white py-1 px-4 rounded"
                @click="handleUserProfileUpdateDp"
              >
                Save
              </button>
            </div>
          </Modal>
          <div class="md:text-center text-start md:mt-4 mt-8 ml-4 md:ml-0">
            <div class="flex xl:flex md:justify-center items-center">
              <h3 class="capitalize font-bold text-md mr-2">
                {{ personal_details && personal_details.name }}
              </h3>
              <!-- @click="isModalOpen = !isModalOpen" -->
              <router-link
                v-if="!isAdminView"
                :to="{ name: 'UserProfileEdit' }"
                class="hover:bg-green-dark ring-1 ring-gray-300 bg-gray-lightest hover:text-white p-1 rounded-full focus:outline-none"
              >
                <Pencil />
              </router-link>
              <!-- <Modal
                v-model="isModalOpen"
                :title="'Edit Profile'"
                :whiteCross="'text-white'"
                :headerClass="'font-semibold'"
              >
                <div
                  class="mb-4 text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
                >
                  <div class="w-full px-2 md:w-1/2">
                    <label class="block mb-1 required text-xs font-medium"
                      >First Name
                    </label>
                    <input
                      type="text"
                      class="w-full h-8 px-3 text-xs font-normal placeholder-gray-light ring-1 ring-gray-200 rounded-lg focus:outline-none capitalize"
                      placeholder="Shelby"
                      v-model="$v.f_name.$model"
                      :classStr="{ 'ring-red-700': $v.f_name.$error }"
                    />
                    <div v-if="$v.f_name.$error">
                      <span
                        class="text-red-700 text-xs"
                        v-if="!$v.f_name.required"
                      >
                        First Name is Required
                      </span>
                    </div>
                  </div>

                  <div class="w-full px-2 md:w-1/2">
                    <label class="block mb-1 required text-xs font-medium"
                      >Last Name</label
                    >
                    <input
                      type="text"
                      class="w-full h-8 px-3 text-xs font-normal placeholder-gray-light ring-1 ring-gray-200 rounded-lg focus:outline-none capitalize"
                      placeholder="Cooper"
                      v-model="$v.l_name.$model"
                      :classStr="{ 'ring-red-700': $v.l_name.$error }"
                    />
                    <div v-if="$v.l_name.$error">
                      <span
                        class="text-red-700 text-xs"
                        v-if="!$v.l_name.required"
                      >
                        Last Name is Required
                      </span>
                    </div>
                  </div>
                </div>

                <div class="mb-4 text-gray-700">
                  <label class="block mb-1 font-medium text-xs pb-1"
                    >Mobile</label
                  >
                  <VuePhoneNumberInput
                    v-model="$v.mobile.$model"
                    :color="phoneTextBoxColor"
                    :error="$v.nationalMobile.$error"
                    :no-example="true"
                    @update="
                      (nationalMobile = $event.nationalNumber),
                        (isd_code = $event.countryCode)
                    "
                    :default-country-code="isd_code"
                    class="rounded-sm focus:outline-none"
                  />
                  <div v-if="$v.nationalMobile.$error">
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.nationalMobile.required"
                    >
                      Mobile number is required
                    </span>
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.nationalMobile.minLength"
                    >
                      Mobile must have at least 10 digits.
                    </span>
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.nationalMobile.maxLength"
                    >
                      Mobile must have at Most 10 digits.
                    </span>
                  </div>
                </div>

                <div class="mb-4 text-gray-700">
                  <label class="block mb-1 required font-medium text-xs"
                    >Date of Birth</label
                  >
                  <DropdownDatepicker
                    :dropdownClass="'mt-1 block pl-3 py-2 ring-1 w-auto pr-1 ring-gray-200 focus:outline-none text-sm rounded-md mr-1 bg-white'"
                    v-if="selectedDate"
                    display-format="dmy"
                    v-model="$v.selectedDate.$model"
                    v-bind:required="true"
                    v-bind:min-age="18"
                    :default-date="selectedDate"
                    submit-format="dd-mm-yyyy"
                  ></DropdownDatepicker>
                  <div v-if="$v.selectedDate.$error">
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.selectedDate.required"
                    >
                      Date of Birth is Required
                    </span>
                  </div>
                </div>

                <div class="font-medium text-xs">
                  <CategoryInput
                    :categoriesList="categoriesList"
                    :categoriesData="categoriesData"
                    :category_id="category_id"
                    :selectedColor="selectedColor"
                    @CategoriesChange="handleCategoryChange"
                    @CategoriesRemove="handleCategoryClick"
                  />
                </div>

                <div class="mb-2 float-right">
                  <button
                    class="h-10 w-20 px-4 m-2 text-green-dark transition-colors duration-150 ring-1 ring-white rounded-lg focus:outline-none hover:ring-green-dark hover:text-green-dark hover:shadow-lg"
                    @click="isModalOpen = !isModalOpen"
                  >
                    Back
                  </button>
                  <TButton :loading="loading" @button="handleEditProfile">
                    Save
                  </TButton>
                </div>
              </Modal> -->
            </div>
            <p
              class="text-sm text-gray-light mt-2"
              :title="personal_details.created_at"
            >
              Member since:
              {{ personal_details && personal_details.created_at && handleDays(personal_details.created_at) || 0 }}
              days
            </p>
          </div>
          <div class="ring-gray-400 ring-1 mt-2 md:block hidden"></div>
        </section>

        <section class="mt-6">
          <div class="antialiased p-2">
            <div class="flex md:justify-center justify-start">
              <nav id="nav" class="w-96 relative">
                
                <ul class="relative flex flex-col">
                  <li>
                    <button
                      type="button"
                      @click="handleTabClick(0)"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:shadow my-1 text-gray-light text-left"
                      :class="
                        selected === 0 ? 'bg-opacity-25 text-green-light' : ''
                      "
                    >
                      Overview
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      @click="handleTabClick(1)"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                      :class="
                        selected === 1 ? 'bg-opacity-25 text-green-light' : ''
                      "
                    >
                        Completed Classes
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      @click="handleTabClick(2)"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                      :class="
                        selected === 2 ? 'bg-opacity-25 text-green-light' : ''
                      "
                    >
                      Invoices
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      @click="handleTabClick(3)"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                      :class="
                          selected === 3 ? 'bg-opacity-25 text-green-light' : ''
                        "
                    >
                        Following
                    </button>
                  </li>
                  <!-- <li>
                    <button
                      type="button"
                      @click="handleTabClick(4)"
                      class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                    >
                      <li
                        class="md:py-2 md:px-4 w-full py-1 px-2"
                        :class="
                          selected === 4 ? 'bg-opacity-25 text-gray-dark' : ''
                        "
                      >
                        Favorite
                      </li>
                    </button>
                  </li> -->
                  <li>
                    <button
                      type="button"
                      @click="handleTabClick(5)"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                      :class="
                          selected === 5 ? 'bg-opacity-25 text-green-light' : ''
                        "
                    >
                      On Demand Classes Library
                    </button>
                  </li>
                  <li v-if="!getTrainerEligibility && !isAdminView">
                    <button
                      type="button"
                      @click="becomeTrainerHandler"
                      class="md:py-2 md:px-4 w-full py-1 px-2 rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:outline-none my-1 text-gray-light text-left"
                      :class="
                          selected === 6 ? 'bg-opacity-25 text-green-light' : ''
                        "
                    >
                      Become a Trainer
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </section>
      </section>

      <section class="md:w-9/12">
        <section class="space-y-4" v-if="tab == 0">
          <section class="md:flex">
            <div class="w-full space-y-4">
              <section class="hidden md:grid">
                <div
                  class="shadow relative"
                  @mouseover="!isAdminView ? isBannerOptionsOpen = true : ''"
                  @mouseleave="!isAdminView ? isBannerOptionsOpen = false : ''"
                >
                  <img
                    class="object-cover w-full rounded-lg shadow h-56"
                    :src="baseUrlSrc(personal_details && personal_details.banner_url)"
                    alt=""
                    @error="defaultImage"
                  />
                  <div class="absolute top-0 right-0 mr-2 mt-2">
                    <div class="flex items-center">
                      <div v-if="isBannerOptionsOpen">
                        <button
                          type="button"
                          class="text-black shadow-lg bg-gray-100 rounded-full p-2"
                          v-if="personal_details && personal_details.banner_url"
                          @click.prevent="handleProfileBannerRemove"
                        >
                          <Trash />
                        </button>
                        <button
                          type="button"
                          class="text-black shadow-lg bg-gray-100 rounded-full p-2"
                          @click.prevent="isBannerModalOpen = !isBannerModalOpen"
                        >
                          <Pencil />
                        </button>
                      </div>

                      <!-- banner modal -->
                      <Modal v-model="isBannerModalOpen" :title="'Edit Banner Image'">
                        <div class="mb-2">
                          <div v-if="bannerImagePreview">
                            <Cropper
                              ref="bannerCropper"
                              class="twitter-cropper"
                              background-class="twitter-cropper__background"
                              foreground-class="twitter-cropper__foreground"
                              image-restriction="stencil"
                              default-boundaries="fill"
                              :stencil-size="stencilSize"
                              :stencil-props="{
                                handlers: {},
                                movable: false,
                                scalable: false,
                                aspectRatio: 16 / 4,
                                previewClass: 'twitter-cropper__stencil',
                              }"
                              :transitions="false"
                              :canvas="true"
                              :debounce="false"
                              :default-size="defaultSize"
                              :min-width="250"
                              :min-height="250"
                              :src="bannerImagePreview"
                              @change="onBannerChange"
                            />
                            <Navigation
                              :zoom="zoom"
                              @change="onBannerZoom"
                              @zoomInBtn="zoomIn"
                              @zoomOutBtn="zoomOut"
                            />
                          </div>
                          <div
                            v-else
                            class="flex justify-center p-4 bg-gray-300 shadow"
                          >
                            <div v-if="personal_details && personal_details.banner_url">
                              <img
                                :src="baseUrlSrc(personal_details && personal_details.banner_url)"
                                alt=""
                                class="object-cover rounded"
                                @error="defaultImage"
                              />
                            </div>
                          </div>
                          <span class="text-gray-700">Upload File</span>
                          <input
                            type="file"
                            class="form-input mt-1 block w-full"
                            @change="handleBannerImageChange"
                          />
                        </div>
                        <div class="mb-2 float-right">
                          <button
                            class="ring-green-dark ring-1 rounded py-1 px-4 mr-2 text-green-dark"
                            @click="propfileBannerUploadToggler"
                          >
                            Cancel
                          </button>
                          <button
                            class="bg-green-dark text-white py-1 px-4 rounded"
                            @click="handleBannerImageUpdate"
                          >
                            Save
                          </button>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <div class="md:flex md:h-48 mt-4 md:space-x-4 space-x-0">
                  <section class="md:w-8/12">
                    <div
                      class="p-6 h-full rounded-lg shadow-lg ring-1 ring-gray-300"
                    >
                      <h3
                        class="text-gray-dark mb-4 font-semibold tracking-wider text-lg"
                      >
                        Subscribed
                      </h3>
                      <div class="flex text-center justify-around items-center">
                        <p class="px-6">
                          <Sessions />
                          Classes<br />
                          <span>{{
                            subscribed && subscribed.session_count
                          }}</span>
                        </p>
                        <p class="px-6">
                          <Courses />
                          Class Packs<br />
                          <span>{{
                            subscribed && subscribed.course_count
                          }}</span>
                        </p>
                        <p class="px-6">
                          <Private />
                          Private<br />
                          <span>{{
                            subscribed && subscribed.private_count
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </section>
                  <section class="md:w-4/12 md:mt-0 mt-4">
                    <div
                      class="relative max-w-xs overflow-hidden rounded-lg shadow-lg"
                      v-if="userUpcomingSessions && userUpcomingSessions.data"
                    >
                      <img
                        class="object-cover w-full h-48"
                        :src="
                          userUpcomingSessions &&
                          userUpcomingSessions.data &&
                          userUpcomingSessions.data[0].thumbnail_url
                        "
                        alt="Flower and sky"
                        style="filter: brightness(0.6)"
                        @error="defaultImage"
                      />
                      <div class="absolute top-0 left-0 px-6 py-4">
                        <h4
                          class="mb-3 text-xl font-semibold tracking-tight text-white"
                        >
                          Upcoming Class
                        </h4>
                        <h4
                          class="mb-3 text-xl font-semibold tracking-tight text-white"
                        >
                          {{
                            userUpcomingSessions &&
                            userUpcomingSessions.data &&
                            userUpcomingSessions.data[0].title
                          }}
                        </h4>
                        <p class="leading-normal text-gray-100">
                          {{
                            userUpcomingSessions &&
                            userUpcomingSessions.data &&
                            handleMonthDateTime(
                              userUpcomingSessions.data[0].start_date
                            )
                          }}
                          {{
                            userUpcomingSessions &&
                            userUpcomingSessions.data &&
                            handleHour12(
                              userUpcomingSessions.data[0].start_date
                            )
                          }}
                          -
                          {{
                            userUpcomingSessions &&
                            userUpcomingSessions.data &&
                            handleHour12(userUpcomingSessions.data[0].end_date)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="p-6 h-full rounded-lg shadow-lg ring-1 ring-gray-300"
                      :style="{
                        'background-image': `url(${require('@/assets/svg/Wallet_BG.svg')})`,
                        'background-size': '110%',
                        'background-position': 'center',
                      }"
                      v-else
                    >
                      <h3
                        class="text-white mb-4 font-semibold tracking-wider text-lg"
                      >
                        <!-- Wallet -->
                      </h3>
                      <router-link
                        :to="{ name: 'SessionsFind', params: { id: 'all' } }"
                        class="text-white"
                      >
                        <p class="text-5xl font-bold space-x-1">
                          <!-- $ <span>{{ intToFloat(walletBalance, 2) }}</span> -->
                          Find Classes
                        </p>
                        <span class="text-lg">
                          <!-- Balance -->
                        </span>
                      </router-link>
                    </div>
                  </section>
                </div>
              </section>
              <section>
                <div
                  class="p-6 h-full rounded-lg shadow-lg ring-1 ring-gray-300"
                >
                  <div class="flex justify-between">
                    <h3
                      class="text-gray-dark inline block mb-4 font-semibold tracking-wider text-lg"
                    >
                      Completed Class
                    </h3>
                    <button
                      type="button"
                      class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                      @click="handleTabClick(1)"
                    >
                    <span class="px-1 whitespace-nowrap">See all</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                    </button>
                  </div>
                  <div
                    class="mt-2"
                    v-if="completed_sessions && completed_sessions.length"
                  >
                    <CompletedSessionList :data="completed_sessions" />
                    <!-- <Pagination
                      v-if="completed_sessions.length"
                      :currentPage="completedCurrentPage"
                      :handlePageChange="completedHandlePageChange"
                      :totalPages="completedTotalPages"
                    /> -->
                  </div>
                  <div
                    class="flex lg:flex-row flex-col justify-around items-center text-xl text-gray-dark mt-4 space-y-8"
                    v-else
                  >
                    <div
                      class="flex flex-col text-lg justify-center text-center"
                    >
                      <span>You don’t seem to have any completed Classes</span>
                      <span
                        >All Classes that you attend will be available
                        here.</span
                      >
                    </div>
                    <img
                      :src="
                        require(`@/assets/svg/completed-sessions-nodata.svg`)
                      "
                      alt="..."
                      class="md:w-72 md:h-56"
                    />
                  </div>
                </div>
              </section>
            </div>
          </section>
          <section class="h-42">
            <div class="p-6 h-full rounded-lg shadow-lg ring-1 ring-gray-300">
              <div class="flex justify-between">
                <h3
                  class="text-gray-dark mb-4 font-semibold tracking-wider text-lg"
                >
                  Followed Trainer
                </h3>
                <button
                  type="button"
                  class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                  @click="handleTabClick(3)"
                >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
                </button>
              </div>
              <div class="mb-4">
                <FollowedTrainer v-if="following.data" :data="following.data" />
              </div>
            </div>
          </section>
        </section>

        <section v-if="tab == 1" class="shadow-lg mt-4">
          <div class="py-3 px-4 lg:px-8 xl:px-4 md:h-screen h-auto rounded-lg bg-white overflow-auto">
            <h3 class="mb-3 text-gray-dark font-bold text-md py-4">
              Completed Classes
            </h3>
            <CompletedSessionList :data="completed_sessions" />
            <!-- <Pagination
              v-if="completed_sessions.length"
              :currentPage="completedCurrentPage"
              :handlePageChange="completedHandlePageChange"
              :totalPages="completedTotalPages"
            /> -->
          </div>
        </section>

        <section v-if="tab == 2">
          <!-- <div class="shadow-lg mt-3 xl:p-4 md:p-4 lg:p-2 bg-white">
            <h3
              class="mb-3 text-gray-dark font-bold text-md"
              v-if="!isWalletSeeAll"
            >
              Wallet
            </h3>
            <section class="md:flex" v-if="!isWalletSeeAll">
              <section
                class="md:w-4/12 w-full mr-4 ring-1 ring-gray-300 rounded-md"
              >
                <div class="shadow h-40 flex justify-center items-center">
                  <div class="text-center">
                    <p class="xl:text-3xl text-xl text-green-light space-x-1">
                      $ <span>{{ intToFloat(walletBalance, 2) }}</span>
                    </p>
                    <span class="text-sm">Balance</span>
                  </div>
                </div>
              </section>
              <section class="md:w-9/12 ring-1 ring-gray-300 rounded-md">
                <div class="shadow md:h-40 p-3 justify-center text-center">
                  <div class="grid gap-4 md:grid-cols-3 grid-cols-2">
                    <div
                      class="bg-gray-lightest h-32 ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-pointer"
                      @click="handleAddMoneyToWallet"
                      v-if="paymentEnableDisable"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$10</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>

                    <div
                      class="bg-gray-lightest h-32 ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-not-allowed"
                      title="Payment is disable"
                      v-else
                      @click="alertFxn"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$10</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>

                    <div
                      class="bg-gray-lightest ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-pointer"
                      title="Payment is disable"
                      @click="handleAddMoneyToWallet"
                      v-if="paymentEnableDisable"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$60</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>

                    <div
                      class="bg-gray-lightest ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-not-allowed"
                      title="Payment is disable"
                      v-else
                      @click="alertFxn"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$60</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>

                    <div
                      class="bg-gray-lightest ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-pointer"
                      @click="handleAddMoneyToWallet"
                      v-if="paymentEnableDisable"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$150</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>

                    <div
                      class="bg-gray-lightest ring-1 ring-gray-300 rounded-b-md rounded-t-md xl:p-3 p-1 cursor-not-allowed"
                      v-else
                      @click="alertFxn"
                    >
                      <h3 class="text-gray-dark xl:mb-3 text-sm">Purchase</h3>
                      <p class="xl:text-2xl text-xl">$150</p>
                      <p class="text-gray-dark text-xs">Get $1 free</p>
                    </div>
                  </div>
                </div>
              </section>
              <PaymentAlertModal v-model="paymentFeatureAlert">
              </PaymentAlertModal>
            </section>

            <section>
              <div class="my-8">
                <div class="md:flex justify-between items-center">
                  <div class="flex">
                    <select
                      :value="historyType"
                      class="bg-transparent text-xs md:px-4 md:py-1 ring-1 ring-gray-400 rounded-lg focus:outline-none"
                      @change="handleChangeHistoryType"
                    >
                      <option value="txnHistory">Purchase History</option>
                      <option value="walletHistory">Wallet History</option>
                      <option value="tips">Tips</option>
                    </select>
                    <div
                      v-if="historyType === 'txnHistory'"
                      class="ml-4 ring-1 ring-gray-300 rounded-lg"
                    >
                      <button
                        type="button"
                        @click="handleChangeTxnHistoryType('sessions')"
                        :class="{
                          'bg-green-light rounded-l-lg text-white text-xs':
                            txnHistoryType === 'sessions',
                        }"
                        class="p-2 focus:outline-none"
                      >
                        Classes
                      </button>
                      <button
                        type="button"
                        @click="handleChangeTxnHistoryType('courses')"
                        :class="{
                          'bg-green-light rounded-r-lg text-white':
                            txnHistoryType === 'courses',
                        }"
                        class="p-2 focus:outline-none text-xs"
                      >
                        Courses
                      </button>
                    </div>
                  </div>
                  <div
                    class="md:relative md:mt-0 md:mr-0 absolute right-0 -mt-8 mr-8"
                  >
                    <button
                      v-if="!isWalletSeeAll"
                      @click="isWalletSeeAll = true"
                      class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                    >
                      See All
                    </button>
                    <button
                      v-else
                      @click="isWalletSeeAll = false"
                      class="ring-1 ring-gray-400 px-2 rounded-lg focus:outline-none flex justify-center items-center"
                    >
                      <span><ChevronLeft /></span>
                      Back
                    </button>
                  </div>
                </div>
                <TableAlt
                  :thead="getTableHead"
                  class="md:mt-8 mt-10 ring-1 rounded ring-blue-light"
                >
                  <tbody
                    class="bg-white divide-y divide-gray-200 md:text-left text-center"
                    v-if="walletTableDataToShow && walletTableDataToShow.length"
                  >
                    <tr
                      v-for="items in walletTableDataToShow"
                      :key="items.date + Math.random().toString()"
                      class="hover:bg-gray-100"
                    >
                      <td
                        class="px-0 md:px-4 py-3 whitespace-nowrap md:text-sm text-xs text-gray-dark capitalize"
                        v-for="item in Object.keys(items)"
                        :key="item"
                      >
                        {{ items[item] || "-" }}
                      </td>
                    </tr>
                  </tbody>
                </TableAlt>
                <div v-if="!walletTableDataToShow.length">
                  <EmptyTable
                    :description="'Complete transactions to see your history.'"
                  />
                </div>
                <Pagination
                  v-if="isWalletSeeAll && walletTotalPages"
                  :currentPage="walletCurrentPage"
                  :handlePageChange="handlePageChange"
                  :totalPages="walletTotalPages"
                />
              </div>
            </section>
          </div> -->
          <UserInvoices></UserInvoices>
        </section>

        <section v-if="tab == 3">
          <div class="shadow-lg mt-4 p-3 md:h-screen h-auto bg-white">
            <div class="flex items-center justify-between">
              <h3 class="mb-3 text-gray-dark font-bold text-md">
                Followed Trainers
              </h3>
            </div>
            <div class="">
              <TableAlt :thead="['Trainer Name', 'Ratings', 'Category', '']">
                <tbody
                  class="bg-white ring-1 ring-gray-200 divide-y divide-gray-200 md:text-left text-center"
                >
                  <tr
                    v-for="d in following.data"
                    :key="d.id"
                    class="hover:bg-blue-lightest md:text-sm text-xs"
                  >
                    <td
                      class="lg:px-6 md:px-2 py-4 whitespace-nowrap text-sm text-gray-dark"
                    >
                      <div class="flex md:flex-row flex-col items-center">
                        <Avatar
                          :classStr="'h-10 w-10 xl:mr-2 md:mr-10 lg:mr-0'"
                          :src="baseUrlSrc(d.thumbnail_url)"
                        />
                        <router-link
                          :to="{
                            name: 'UserTrainerAbout',
                            params: { trainer_id: d.trainer_id },
                          }"
                        >
                          <span class="capitalize"
                            >{{ d.f_name }} {{ d.l_name }}</span
                          >
                        </router-link>
                      </div>
                    </td>
                    <td
                      class="lg:px-6 md:px-2 py-4 whitespace-nowrap text-sm text-gray-dark"
                    >
                      <div class="flex md:flex-row flex-col items-center">
                        <Rating :data="d.average_rating" />
                        <span
                          >{{ d.average_rating }}({{
                            d.total_users_rated
                          }})</span
                        >
                      </div>
                    </td>
                    <td
                      class="lg:px-6 md:px-2 py-4 whitespace-nowrap text-sm text-gray-dark"
                    >
                      Category 1
                    </td>
                    <td
                      class="lg:px-6 md:px-2 py-4 whitespace-nowrap text-sm text-gray-dark"
                    >
                      <FollowTrainerButton
                        :isFollow="d.is_follow"
                        :handleUserFollowTrainer="handleUserFollowTrainer"
                        :trainerId="d.trainer_id"
                        classStr="py-1 px-2 w-20 text-sm"
                      />
                    </td>
                  </tr>
                </tbody>
              </TableAlt>
              <div class="py-4 m-auto w-100">
                <div class="text-center">
                  <Pagination
                    v-if="following && following.data && following.data.length"
                    :currentPage="followingCurrentPage"
                    :handlePageChange="followingHandlePageChange"
                    :totalPages="followingTotalPages"
                  />
                </div>
              </div>

              <p
                class="text-gray-light text-sm mt-2"
                v-if="following && following.length == 0"
              >
                No data found.
              </p>
            </div>
          </div>

          <Modal :title="'Unfollow'" v-model="isFollowConfirmationModalOpen">
            <div class="flex flex-col justify-center pb-4">
              <p class="text-left">
                Are you sure you want to Unfollow this trainer?
              </p>
              <div class="flex justify-end w-full mt-8">
                <button
                  class="w-16 py-1 px-2 text-sm text-green-light ring-1 ring-green-light rounded-md mr-4"
                  @click="isFollowConfirmationModalOpen = false"
                >
                  Cancel
                </button>
                <button
                  class="w-16 py-1 px-2 text-sm bg-green-light text-white rounded-md"
                  @click="handleUnfollowTrainer"
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        </section>

        <!-- <section v-if="tab == 4">
          <div
            class="shadow-lg mt-3 pb-6 pt-3 px-4 lg:px-8 xl:px-4 h-full rounded-lg bg-white"
          >
            <div class="flex items-center justify-between">
              <h3
                class="text-xl font-semibold leading-normal mt-0 mb-2 text-gray-dark"
              >
                Favorites
              </h3>
              <button
                type="button"
                class="h-8 px-4 m-2 text-sm text-gray-dark transition-colors duration-150 ring-1 ring-gray-dark rounded-lg focus:shadow-outline hover:bg-gray-100"
                @click.prevent="handleFiltersModal"
              >
                <div class="flex items-center space-x-1">
                  <span>Filters</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                    />
                  </svg>
                </div>
              </button>
            </div>
            <Modal
              v-model="isFilterModalOpen"
              :classStr="'max-w-lg'"
              :title="'Filters'"
            >
              <hr class="text-gray-400 mb-4" />
              <div
                class="divide-y space-y-4 overflow-auto"
                style="height: 70vh"
              >
                <div>
                  <h1
                    class="text-lg font-normal leading-normal mt-0 mb-2 text-gray-dark"
                  >
                    Category
                  </h1>
                  <div
                    class="grid md:grid-cols-3 grid-cols-2 gap-4"
                    v-if="categoriesList && categoriesList.length"
                  >
                    <button
                      type="button"
                      class="h-10 items-center text-left transition-colors duration-150 ring-1 ring-gray-300 rounded-lg focus:outline-none"
                      :class="
                        category == d.id
                          ? 'text-white bg-green-light'
                          : 'text-gray-light'
                      "
                      v-for="d in categoriesList"
                      :key="d.id"
                      @click.prevent="category = d.id"
                    >
                      <div class="flex justify-between px-2">
                        <span class="mr-2">{{ d.name }}</span>
                        <div v-if="category == d.id"><X /></div>
                        <div v-else><Plus /></div>
                      </div>
                    </button>
                  </div>
                </div>
                <div>
                  <hr class="text-gray-400 mb-4" />
                  <h1
                    class="text-lg font-normal leading-normal mt-0 mb-2 text-gray-dark"
                  >
                    Language
                  </h1>
                  <div
                    class="grid grid-cols-3 gap-4"
                    v-if="languagesList && languagesList.length"
                  >
                    <button
                      type="button"
                      class="h-8 text-left transition-colors duration-150 ring-1 ring-gray-300 rounded-lg focus:outline-none"
                      :class="
                        language == d.id
                          ? 'text-white bg-green-light'
                          : 'text-gray-light'
                      "
                      v-for="d in languagesList"
                      :key="d.id"
                      @click.prevent="language = d.id"
                    >
                      <div class="flex justify-between px-2">
                        <span class="mr-2">{{ d.language }}</span>
                        <div v-if="language == d.id"><X /></div>
                        <div v-else><Plus /></div>
                      </div>
                    </button>
                  </div>
                </div>
                <div>
                  <hr class="text-gray-400 mb-4" />
                  <h1
                    class="text-lg font-normal leading-normal mt-0 mb-2 text-gray-dark"
                  >
                    Type
                  </h1>
                  <div class="flex justify-center">
                    <button
                      class="flex flex-col mr-6 items-center h-24 px-5 transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                      :class="
                        entity_type == SESSION
                          ? 'bg-green-light text-white'
                          : 'text-gray-dark'
                      "
                      @click.prevent="entity_type = SESSION"
                    >
                      <svg
                        width="50"
                        height="65"
                        viewBox="0 0 65 65"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#qqf9279wva)">
                          <path
                            d="M5.873 21.956a3.1 3.1 0 0 1-.058-.067l.013.003-.104-.119a3.428 3.428 0 0 0-.161-.177 5.04 5.04 0 0 0-1.98-1.224l-2.45-.8a.971.971 0 0 1-.468-1.47.975.975 0 0 1 .468-.353l2.45-.8a5.053 5.053 0 0 0 1.949-1.226c.116-.134.225-.272.327-.415.364-.447.652-.95.853-1.49l.816-2.509A.972.972 0 0 1 9 10.841c.048.04.093.086.133.134.094.094.167.21.214.333l.801 2.447a5.057 5.057 0 0 0 3.196 3.194l2.45.8.05.011a.97.97 0 0 1 .468 1.47.96.96 0 0 1-.47.353l-2.45.8c-.744.249-1.42.669-1.973 1.225a5.054 5.054 0 0 0-1.223 1.973l-.8 2.448-.023.06a.959.959 0 0 1-.222.275.38.38 0 0 0-.043.057.259.259 0 0 1-.067.076.973.973 0 0 1-1.33-.208.95.95 0 0 1-.14-.266l-.8-2.447a5.056 5.056 0 0 0-.8-1.507 1.626 1.626 0 0 0-.099-.113h.001zm32.268-.944a7.997 7.997 0 0 1-5.657 13.655 8.003 8.003 0 0 1-7.391-11.06 7.998 7.998 0 0 1 7.391-4.938c2.123 0 4.157.843 5.659 2.343h-.002zm-8.957 2.357a4.666 4.666 0 1 0 6.6 6.6 4.666 4.666 0 0 0-6.6-6.6zm24.97-12.698H11.942l.734 2.25c.116.352.313.671.573.934.034.032.07.061.11.088.029.02.057.04.082.064h40.715a1.667 1.667 0 0 1 1.666 1.666v32.662A1.667 1.667 0 0 1 54.155 50H45.82v-8.334a4.333 4.333 0 0 0-4.333-4.334H23.481a4.333 4.333 0 0 0-4.333 4.334v8.33h-8.333a1.666 1.666 0 0 1-1.668-1.666V29.269a3.58 3.58 0 0 1-.667.071 3.613 3.613 0 0 1-2.099-.667c-.21-.162-.4-.347-.568-.552v20.212a4.998 4.998 0 0 0 5 5h43.342a4.999 4.999 0 0 0 5-5.002V15.669a4.997 4.997 0 0 0-5-4.998zM22.484 49.997v-8.33a1 1 0 0 1 1-1h18.002a1 1 0 0 1 1 1v8.33H22.483zm-8.195-20.996a2.952 2.952 0 0 0 1.84-1.862l.465-1.427a.563.563 0 0 1 .858-.268.557.557 0 0 1 .206.267l.464 1.428A2.934 2.934 0 0 0 19.988 29l1.427.464.029.008a.562.562 0 0 1 .37.532.563.563 0 0 1-.37.531l-1.43.465a2.944 2.944 0 0 0-1.867 1.863l-.467 1.427a.563.563 0 0 1-.856.266.555.555 0 0 1-.207-.266l-.464-1.427a2.932 2.932 0 0 0-1.866-1.87l-1.427-.465a.567.567 0 0 1-.275-.859.559.559 0 0 1 .274-.205l1.429-.464z"
                            fill="#364B69"
                          />
                        </g>
                        <defs>
                          <clipPath id="qqf9279wva">
                            <path
                              fill="#fff"
                              transform="translate(.488 .004)"
                              d="M0 0h64v64H0z"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <span>Classes Only</span>
                    </button>

                    <button
                      class="flex flex-col items-center h-24 px-5 transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                      :class="
                        entity_type == COURSE
                          ? 'bg-green-light text-white'
                          : 'text-gray-dark'
                      "
                      @click.prevent="entity_type = COURSE"
                    >
                      <svg
                        width="50"
                        height="65"
                        viewBox="0 0 65 65"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M36.3058 30.6706C36.3058 31.7314 35.8844 32.7489 35.1343 33.499C34.3841 34.2491 33.3667 34.6706 32.3058 34.6706C31.245 34.6706 30.2275 34.2491 29.4774 33.499C28.7273 32.7489 28.3058 31.7314 28.3058 30.6706C28.3058 29.6097 28.7273 28.5923 29.4774 27.8421C30.2275 27.092 31.245 26.6706 32.3058 26.6706C33.3667 26.6706 34.3841 27.092 35.1343 27.8421C35.8844 28.5923 36.3058 29.6097 36.3058 30.6706ZM18.9725 37.3372C19.4978 37.3372 20.0179 37.2338 20.5032 37.0328C20.9885 36.8317 21.4295 36.5371 21.8009 36.1657C22.1724 35.7942 22.467 35.3533 22.668 34.868C22.869 34.3827 22.9725 33.8625 22.9725 33.3372C22.9725 32.812 22.869 32.2918 22.668 31.8065C22.467 31.3212 22.1724 30.8802 21.8009 30.5088C21.4295 30.1374 20.9885 29.8427 20.5032 29.6417C20.0179 29.4407 19.4978 29.3372 18.9725 29.3372C17.9116 29.3372 16.8942 29.7587 16.1441 30.5088C15.3939 31.259 14.9725 32.2764 14.9725 33.3372C14.9725 34.3981 15.3939 35.4155 16.1441 36.1657C16.8942 36.9158 17.9116 37.3372 18.9725 37.3372V37.3372ZM45.6392 37.3372C46.1644 37.3372 46.6846 37.2338 47.1699 37.0328C47.6552 36.8317 48.0961 36.5371 48.4676 36.1657C48.839 35.7942 49.1337 35.3533 49.3347 34.868C49.5357 34.3827 49.6392 33.8625 49.6392 33.3372C49.6392 32.812 49.5357 32.2918 49.3347 31.8065C49.1337 31.3212 48.839 30.8802 48.4676 30.5088C48.0961 30.1374 47.6552 29.8427 47.1699 29.6417C46.6846 29.4407 46.1644 29.3372 45.6392 29.3372C44.5783 29.3372 43.5609 29.7587 42.8107 30.5088C42.0606 31.259 41.6392 32.2764 41.6392 33.3372C41.6392 34.3981 42.0606 35.4155 42.8107 36.1657C43.5609 36.9158 44.5783 37.3372 45.6392 37.3372V37.3372ZM5.63916 16.8466C5.63916 13.0039 9.15383 10.2012 12.8178 10.7132C17.0205 11.3079 23.7965 12.0039 32.3058 12.0039C40.8152 12.0039 47.5912 11.3052 51.7938 10.7159C55.4578 10.2012 58.9725 13.0039 58.9725 16.8466V47.1639C58.9725 51.0039 55.4578 53.8039 51.7992 53.2919C45.3386 52.4161 38.8255 51.9857 32.3058 52.0039C23.7992 52.0039 17.0205 52.7026 12.8152 53.2919C9.15383 53.8039 5.64183 51.0039 5.63916 47.1612V16.8466ZM12.2605 14.6759C10.8632 14.4812 9.63916 15.5772 9.63916 16.8466V47.1639C9.63916 48.4306 10.8605 49.5266 12.2605 49.3292C12.6952 49.2706 13.1538 49.2066 13.6392 49.1452V42.6706C13.6392 41.9633 13.9201 41.2851 14.4202 40.785C14.9203 40.2849 15.5986 40.0039 16.3058 40.0039H22.9725V48.2812C24.2445 48.2039 25.5778 48.1399 26.9725 48.0946V40.0039C26.9725 39.2967 27.2534 38.6184 27.7535 38.1183C28.2536 37.6182 28.9319 37.3372 29.6392 37.3372H34.9725C35.6797 37.3372 36.358 37.6182 36.8581 38.1183C37.3582 38.6184 37.6392 39.2967 37.6392 40.0039V48.0919C39.0338 48.1399 40.3672 48.2039 41.6392 48.2786V40.0039H48.3058C49.0131 40.0039 49.6913 40.2849 50.1914 40.785C50.6915 41.2851 50.9725 41.9633 50.9725 42.6706V49.1452C51.4578 49.2066 51.9192 49.2706 52.3512 49.3319C53.7512 49.5266 54.9725 48.4306 54.9725 47.1612V16.8466C54.9725 15.5772 53.7485 14.4812 52.3512 14.6759C47.9965 15.2892 41.0312 16.0039 32.3058 16.0039C23.5805 16.0039 16.6152 15.2866 12.2605 14.6759V14.6759Z"
                          fill="#364B69"
                        />
                      </svg>
                      <span>Class Packs Only</span>
                    </button>
                  </div>
                </div>
                <hr class="text-gray-400 mb-4" />
              </div>
              <hr class="text-gray-400 mb-4" />
              <div class="flex items-center justify-between mt-2">
                <button
                  type="button"
                  class="h-10 px-4 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
                  @click.prevent="handleFiltersModal"
                >
                  Clear All
                </button>
                <TButton :loading="loading" @button="handleApplyFilter">
                  Apply Filter(s)
                </TButton>
              </div>
            </Modal>
            <FavouriteSessionCardList
              :data="userSessionFavourite && userSessionFavourite.data"
            />
            <Pagination
              v-if="userSessionFavourite && userSessionFavourite.total"
              :currentPage="favouriteCurrentPage"
              :handlePageChange="favouriteHandlePageChange"
              :totalPages="userSessionFavourite.last_page"
            />
          </div>
        </section> -->
        <section v-if="tab == 5">
          <div
            class="shadow-lg mt-3 py-3 px-4 lg:px-8 xl:px-4 md:h-screen h-auto rounded-lg bg-white overflow-auto"
          >
            <h3 class="mb-5 text-gray-dark font-bold text-md">
              On Demand Classes Library
            </h3>
            <VodLibrary :data="completed_sessions" />

            <!-- <Pagination
              v-if="completed_sessions.length"
              :currentPage="completedCurrentPage"
              :handlePageChange="completedHandlePageChange"
              :totalPages="completedTotalPages"
            /> -->
          </div>
        </section>
      </section>
    </section>
  </component>
</template>

<script>
import CompletedSessionList from "@/components/CompletedSessionList";
import FollowedTrainer from "@/components/FollowedTrainer";
import UserInvoices from "./UserInvoices.vue";
import FollowTrainerButton from "@/components/FollowTrainerButton";
import VodLibrary from "@/components/VodLibrary.vue";
import AdminProfileLayout from "@/views/admin/AdminProfileLayout.vue";

import {
  Courses,
  Pencil,
  Private,
  Sessions,
  Trash,
  ChevronLeft,
  Plus,
  X,
} from "@/components/icons";
import {
  Avatar,
  Modal,
  Rating,
  TableAlt,
  Pagination,
  CategoryInput,
  EmptyTable,
  TButton,
} from "@/components/t-components";
import UserLayout from "@/components/layouts/UserLayout";
import CircleStencil from "@/components/cropper/CircleStencil";
import Navigation from "@/components/cropper/Navigation";
import DropdownDatepicker from "@/components/vue-dropdown-datepicker/dropdown-datepicker";
import PaymentAlertModal from "@/components/user/PaymentAlertModal";
// import FavouriteSessionCardList from "@/components/user/FavouriteSessionCardList";
import { mapGetters, mapActions } from "vuex";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
// import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  name: "UserProfile",
  components: {
    TButton,
    Cropper,
    Navigation,
    Courses,
    Pencil,
    Private,
    Sessions,
    Trash,
    UserLayout,
    UserInvoices,
    CompletedSessionList,
    FollowedTrainer,
    DropdownDatepicker,
    Avatar,
    Modal,
    Rating,
    TableAlt,
    Pagination,
    ChevronLeft,
    FollowTrainerButton,
    VuePhoneNumberInput,
    CategoryInput,
    PaymentAlertModal,
    EmptyTable,
    // FavouriteSessionCardList,
    AdminProfileLayout,
    VodLibrary,
    Plus,
    X,
  },
  data() {
    return {
      tab: 0,
      selected: 0,
      // f_name: "",
      // l_name: "",
      // phoneTextBoxColor: "#e2e8f0",
      // selectedColor: "bg-blue-darkest",
      // mobile: "",
      // nationalMobile: "",
      // selectedDate: "",
      thumbnailImage: "",
      thumbnailImagePreview: "",
      bannerImage: "",
      bannerImagePreview: "",
      // category_id: "",
      // categoriesData: [],
      // isModalOpen: false,
      personal_details: [],
      completed_sessions: [],
      following: [],
      wallet: [],
      walletBalance: "",
      stencil: CircleStencil,
      isProfileOptionsOpen: false,
      zoom: 0,
      paymentStatus: {
        0: "NOT_NEEDED",
        1: "Pending",
        2: "PROCESSING",
        3: "COMPLETE",
        4: "FAILED",
      },
      historyType: "txnHistory",
      txnHistoryType: "sessions",
      sessionPurchase: [],
      coursePurchase: [],
      creditPurchase: [],
      walletTableDataType: "sessions",
      walletTableDataToShow: [],
      isWalletSeeAll: false,
      walletCurrentPage: 1,
      completedCurrentPage: 1,
      // favouriteCurrentPage: 1,
      completedTotalPages: 0,
      walletTotalPages: 0,
      thumbnail_url: "",
      isProfileImageModalOpen: false,
      isFollowConfirmationModalOpen: false,
      trainerId: "",
      subscribed: {},
      followingTotalPages: 0,
      followingCurrentPage: 1,
      paymentFeatureAlert: false,
      // isd_code: "",
      paymentEnableDisable: "",
      isFilterModalOpen: false,
      category: "",
      language: "",
      entity_type: "",
      // loading: false,
      currentComponent: 'UserLayout',
      isBannerOptionsOpen: false,
      isBannerModalOpen: false
    };
  },
  props: [
    'callerComp'
  ],
  // validations: {
  // f_name: {
  //   required,
  // },
  // l_name: {
  //   required,
  // },
  // selectedDate: {
  //   required,
  // },
  // category_id: {
  //   required,
  // },
  // categoriesData: {
  //   required,
  //   maxLength: maxLength(4),
  // },
  // mobile: {
  //   required,
  //   minLength: minLength(10),
  // },
  // nationalMobile: {
  //   required,
  //   maxLength: maxLength(10),
  //   minLength: minLength(10),
  // },
  // },
  watch: {
    watchUserProfile(userProfile) {
      this.thumbnail_url = userProfile.personal_details.thumbnail_url;
    },

    walletTableDataType: async function () {
      if (!this.isWalletSeeAll) {
        this.setDataToShowInTable();
      } else {
        this.walletCurrentPage = 1;
        const query = {
          page: 1,
        };
        this.handlePaginationAPICall(query);
      }
    },

    isWalletSeeAll: async function () {
      if (!this.isWalletSeeAll) {
        this.setDataToShowInTable();
      } else {
        this.walletCurrentPage = 1;
        const query = {
          page: 1,
        };
        this.handlePaginationAPICall(query);
      }
    },
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "userSessionTxnHistory",
      "userCourseTxnHistory",
      "transactionHistoryTips",
      "userCreditPurchaseHistory",
      // "categoriesList",
      "languagesList",
      "checkPaymentEnableOrDisable",
      // "userSessionFavourite",
      "userUpcomingSessions",
    ]),

    watchUserProfile() {
      return this.userProfile;
    },

    getTableHead() {
      if (this.walletTableDataType === "sessions") {
        return ["Sessions", "Slot", "Amount", "Date", "Status"];
      } else if (this.walletTableDataType === "courses") {
        return ["Course", "Slot", "Amount", "Date", "Status"];
      } else if (this.walletTableDataType === "tips") {
        return ["Trainer", "Session", "Amount", "Date", "Status"];
      } else {
        return ["Credits", "Transaction ID", "Amount", "Date", "Status"];
      }
    },
    isAdminView () {
      return this.callerComp && this.callerComp.length && this.callerComp === 'adminProfileViewer'
    },
    getTrainerEligibility () {
      return this.getUser() && this.getUser().isRoleSelected
    }
  },
  methods: {
    ...mapActions([
      "getUserProfile",
      "userProfileUpdate",
      "getUserSessionTxnHistory",
      "getUserCourseTxnHistory",
      "postTransactionHistoryTips",
      "getUserCreditPurchaseHistory",
      "userProfileRemoveDp",
      "userProfileUpdateDp",
      // "getCategoriesList",
      "getLanguagesList",
      "userFollowTrainer",
      "getCheckPaymentEnableOrDisable",
      // "getUserSessionFavourite",
      "getUserUpcomingSessions",
    ]),

    // handleCategoryChange(event) {
    //   const data = {
    //     id: event.target.value,
    //     text: event.target.options[event.target.options.selectedIndex].text,
    //   };
    //   if (data.id == "") {
    //     return;
    //   }
    //   const index = this.categoriesData.findIndex((e) => e.id === data.id);
    //   if (index === -1) {
    //     this.categoriesData.push(data);
    //     this.category_id = data.id;
    //   }
    // },

    // handleCategoryClick(id) {
    //   const index = this.categoriesData.findIndex((e) => e.id === id);
    //   if (index !== -1) {
    //     this.categoriesData.splice(index, 1);
    //     this.category_id = this.categoriesData[0].id;
    //   }
    // },

    handleTabClick(val) {
      this.tab = val;
      this.selected = val;
    },

    async handlePageChange(page) {
      this.walletCurrentPage = page;

      const query = {
        page,
      };
      this.handlePaginationAPICall(query);
    },

    // async handleEditProfile() {
    //   this.$v.$touch();

    //   if (this.$v.$invalid) {
    //     console.log("invalid");
    //   } else {
    //     // this.loading = true;
    //     let data = new FormData();
    //     data.append("f_name", this.f_name);
    //     data.append("l_name", this.l_name);
    //     data.append("dob", this.selectedDate);
    //     if (this.mobile) {
    //       data.append("isd_code", this.isd_code);
    //       data.append("mobile", this.nationalMobile);
    //     }
    //     for (var i = 0; i < this.categoriesData.length; i++) {
    //       data.append("category_id[" + i + "]", this.categoriesData[i].id);
    //     }
    //     await this.userProfileUpdate(data);
    //     this.isModalOpen = false;
    //     // this.loading = false;
    //     this.fetchProfileData({
    //       page: this.followingCurrentPage,
    //     });
    //   }
    // },

    async handleUserProfileRemoveDp() {
      var c = confirm("Are you sure want to remove?");
      if (c) {
        await this.userProfileRemoveDp();
      }
      this.fetchProfileData({page: this.followingCurrentPage});
    },

    async handleUserProfileUpdateDp() {
      let data = new FormData();
      data.append("thumbnail_image", this.thumbnailImage);
      await this.userProfileUpdateDp(data);
      this.isProfileImageModalOpen = !this.isProfileImageModalOpen;
      const query = {
        page: this.followingCurrentPage,
      };
      this.fetchProfileData(query);
    },

    blobToFile(blob) {
      return new File([blob], `my_image${new Date()}.jpeg`);
    },

    // cropper change
    onChange() {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      }
      const { canvas } = cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          this.thumbnailImage = this.blobToFile(blob);
        }, "image/jpeg");
      } else {
        console.log("canvas is not defined");
      }
    },
    onBannerChange() {
      const cropper = this.$refs.bannerCropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      }
      const { canvas } = cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          this.bannerImage = this.blobToFile(blob);
        }, "image/jpeg");
      } else {
        // console.log("canvas is not defined");
      }
    },
    handleBannerImageChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }
      this.bannerImage = files[0];
      this.createBannerImage(this.bannerImage);
    },

    // cropper stencil-size
    stencilSize({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width) - 48,
        height: Math.min(boundaries.height, boundaries.width) - 48,
      };
    },

    // cropper default-size
    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    // navigation change
    onZoom(value) {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
              ((1 - value) * cropper.imageSize.height + minHeight)
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
              ((1 - value) * cropper.imageSize.width + minWidth)
          );
        }
      }
    },
    onBannerZoom(value) {
      const cropper = this.$refs.bannerCropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
              ((1 - value) * cropper.imageSize.height + minHeight)
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
              ((1 - value) * cropper.imageSize.width + minWidth)
          );
        }
      }
    },

    handleFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      var imageType = ["image/jpeg", "image/png"];
      var included = imageType.includes(files[0]["type"]);
      if (!included) {
        alert("File should be jpeg and png.");
        return;
      }

      this.thumbnailImage = files[0];
      this.createThumbnailImage(this.thumbnailImage);
    },

    createThumbnailImage(file) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnailImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createBannerImage(file) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.bannerImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
     //Method to Zoom in with buttons with navigation event coming from child(Navigation)
     zoomIn(value) {
      value += 0.011;

      this.onBannerZoom(value);
    },
    //Method to Zoom out with buttons with navigation event coming from child(Navigation)
    zoomOut(value) {
      value -= 0.011;

      this.onBannerZoom(value);
    },

    handleAddMoneyToWallet() {
      const paymentSuccessRedirectProps = {
        redirectUrl: this.$route.path,
        componentName: "profile",
      };
      localStorage.setItem(
        "paymentSuccessRedirectProps",
        JSON.stringify(paymentSuccessRedirectProps)
      );

      this.$router.push({ name: "UserAddMoney" });
    },

    handleChangeHistoryType(event) {
      this.historyType = event.target.value;
      if (event.target.value === "txnHistory") {
        this.txnHistoryType = "sessions";
        this.walletTableDataType = "sessions";
      } else if (event.target.value === "tips") {
        this.walletTableDataType = "tips";
      } else {
        this.walletTableDataType = "wallet";
      }
    },

    handleChangeTxnHistoryType(type) {
      this.txnHistoryType = type;
      this.walletTableDataType = type;
    },

    setDataToShowInTable(data) {
      const tableData = [];
      if (this.walletTableDataType === "sessions") {
        let sessionPurchase = this.sessionPurchase;
        if (data) {
          sessionPurchase = data;
        }

        sessionPurchase.map((e) => {
          tableData.push({
            title: e.title || "-",
            slot: `${this.formatDateTime(e.start_date)} - ${this.formatDateTime(
              e.end_date,
              "h:mm A"
            )}`,
            amount: e.cost ? `$${e.cost}` : "$0",
            date: this.handleMonthDateTime(e.updated_at) || "-",
            status: this.paymentStatus[e.payment_status] || "-",
          });
          return null;
        });
      } else if (this.walletTableDataType === "courses") {
        let coursePurchase = this.coursePurchase;
        if (data) {
          coursePurchase = data;
        }
        coursePurchase.map((e) => {
          tableData.push({
            title: e.title || "-",
            slot: `${this.formatDateTime(
              e.start_date,
              "MMM D"
            )} - ${this.formatDateTime(e.end_date, "MMM D, YYYY")}`,
            amount: e.cost ? `$${e.cost}` : "$0",
            date: this.handleMonthDateTime(e.updated_at) || "-",
            status: this.paymentStatus[e.payment_status] || "-",
          });
          return null;
        });
      } else if (this.walletTableDataType === "tips") {
        let coursePurchase = this.coursePurchase;
        if (data) {
          coursePurchase = data;
        }
        coursePurchase.map((e) => {
          tableData.push({
            title: "trainer 1",
            slot: e.title || "-",
            amount: e.cost ? `$${e.cost}` : "-",
            date: this.dateFormat(e.updated_at) || "-",
            status: this.paymentStatus[e.payment_status] || "-",
          });
          return null;
        });
      } else {
        let creditPurchase = this.creditPurchase;
        if (data) {
          creditPurchase = data;
        }
        creditPurchase &&
          creditPurchase.map((e) => {
            tableData.push({
              credits: e.credits ? `${e.credits} CR` : "-",
              txnId: e.transaction_id || "-",
              amount: e.amount ? `$${e.amount}` : "-",
              date: this.handleMonthDateTime(e.updated_at) || "-",
              paymentStatus: this.paymentStatus[e.payment_status] || "-",
            });
            return null;
          });
      }
      this.walletTableDataToShow = tableData;
    },

    getTotalPages(count, pageSize = 10) {
      if (!count) {
        return null;
      }
      if (count % pageSize === 0) {
        return Math.floor(parseInt(count, 10) / pageSize);
      }
      return Math.floor(parseInt(count, 10) / pageSize) + 1;
    },

    async handlePaginationAPICall(query) {
      let data = [];
      let totalPages = null;
      this.walletTableDataToShow = [];
      this.walletTotalPages = 0;
      if (this.walletTableDataType === "sessions") {
        await this.getUserSessionTxnHistory(query);
        data = this.userSessionTxnHistory.data;
        totalPages = this.getTotalPages(
          this.userSessionTxnHistory.total,
          this.userSessionTxnHistory.per_page
        );
      } else if (this.walletTableDataType === "courses") {
        await this.getUserCourseTxnHistory(query);
        data = this.userCourseTxnHistory.data;
        totalPages = this.getTotalPages(
          this.userCourseTxnHistory.total,
          this.userCourseTxnHistory.per_page
        );
      } else if (this.walletTableDataType === "tips") {
        var payload = {
          start_date:
            new Date().getFullYear() +
            "-" +
            new Date().getMonth() +
            "-" +
            new Date().getDate(),
          end_date:
            new Date().getFullYear() +
            "-" +
            new Date().getMonth() +
            "-" +
            new Date().getDate(),
        };
        await this.postTransactionHistoryTips({ payload, query });
        data = this.transactionHistoryTips.data;
        totalPages = this.getTotalPages(
          this.transactionHistoryTips.total,
          this.transactionHistoryTips.per_page
        );
      } else {
        await this.getUserCreditPurchaseHistory(query);

        data = this.userCreditPurchaseHistory.data;
        totalPages = this.getTotalPages(
          this.userCreditPurchaseHistory.total,
          this.userCreditPurchaseHistory.per_page
        );
      }
      this.walletTotalPages = totalPages;
      this.setDataToShowInTable(data);
    },

    async fetchProfileData(query) {
      !this.isAdminView ? await this.getUserProfile({ query }) : ''
      this.personal_details = this.userProfile.personal_details;

      this.completed_sessions =
        this.userProfile.completed_sessions &&
        this.userProfile.completed_sessions.data;
      this.subscribed = this.userProfile.subscribed;
      this.following = this.userProfile.following;
      // this.f_name = this.personal_details && this.personal_details.f_name;
      // this.l_name = this.personal_details && this.personal_details.l_name;
      // this.nationalMobile =
      //   this.personal_details && this.personal_details.mobile;
      // this.mobile = this.personal_details && this.personal_details.mobile;
      // this.isd_code = this.personal_details.isd_code;
      // this.selectedDate = this.personal_details && this.personal_details.dob;
      this.coursePurchase =
        this.userProfile.wallet && this.userProfile.wallet.course_purchase;
      const sessionPurchase =
        this.userProfile.wallet && this.userProfile.wallet.session_purchase;
      this.creditPurchase =
        this.userProfile.wallet && this.userProfile.wallet.credits_purchase;
      this.sessionPurchase = sessionPurchase;
      this.walletBalance = this.userProfile.wallet_balance;
      this.thumbnail_url = this.personal_details.thumbnail_url;
      this.completedCurrentPage = this.userProfile.completed_sessions.current_page;
      this.completedTotalPages = this.userProfile.completed_sessions.last_page;
      !this.isAdminView ? this.setDataToShowInTable(sessionPurchase) : ''
    },

    // getCategoriesData(ids, names) {
    //   const idsArray = ids && ids.split(",");
    //   const namesArray = names && names.split(",");
    //   idsArray &&
    //     idsArray.forEach((e, i) => {
    //       this.categoriesData.push({ id: e, text: namesArray[i] });
    //     });
    // },

    async handleUserFollowTrainer(id, val) {
      if (!val) {
        this.isFollowConfirmationModalOpen = true;
        this.trainerId = id;
      } else {
        const data = {
          trainer_id: id,
          is_follow: val,
        };

        await this.userFollowTrainer(data);
        this.following.map((d) => {
          if (d.trainer_id == id) {
            d.is_follow = val;
          }
        });
      }
    },

    async handleUnfollowTrainer() {
      const data = {
        trainer_id: this.trainerId,
        is_follow: 0,
      };

      await this.userFollowTrainer(data);
      await this.fetchProfileData(data);
      this.isFollowConfirmationModalOpen = false;
    },

    async followingHandlePageChange(page) {
      this.followingCurrentPage = page;
      const query = {
        page,
      };
      await this.fetchProfileData(query);
    },

    // async favouriteHandlePageChange(page) {
    //   this.favouriteCurrentPage = page;
    //   await this.getUserSessionFavourite({ page: this.favouriteCurrentPage });
    // },

    async completedHandlePageChange(page) {
      this.completedCurrentPage = page;
      const query = {
        page,
      };
      await this.fetchProfileData(query);
    },

    alertFxn() {
      this.paymentFeatureAlert = true;
    },

    handleFiltersModal() {
      this.isFilterModalOpen = !this.isFilterModalOpen;
    },

    async handleApplyFilter() {
      // this.loading = true;
      const params = {
        category: this.category,
        language: this.language,
        entity_type: this.entity_type,
      };
      await this.getUserSessionFavourite(params);
      // this.loading = false;
      this.handleFiltersModal();
    },
    propfileUploadToggler () {
      this.isProfileImageModalOpen = !this.isProfileImageModalOpen;
      this.thumbnailImagePreview = ''
    },
    propfileBannerUploadToggler () {
      this.isBannerModalOpen = !this.isBannerModalOpen;
      this.bannerImagePreview = ''
    },
    becomeTrainerHandler () {
      this.$router.push({ name: "Register" });
    },
    async handleBannerImageUpdate() {
      let data = new FormData();
      data.append("banner_image", this.bannerImage);
      await this.$store.dispatch('userProfileUpdateBanner', data);
      this.isBannerModalOpen = !this.isBannerModalOpen;
      const query = {
        page: this.followingCurrentPage,
      };
      this.fetchProfileData(query);
    },
    handleProfileBannerRemove() {
      var c = confirm("Are you sure want to remove?");
      if (c) {
        this.$store.dispatch('userProfileBannerRemove').then(() => {
          if (this.personal_details && this.personal_details.banner_url) {
            this.personal_details.banner_url = ''
            this.bannerImagePreview = ''
          }
        })
      }
    }
  },
  async created() {
    const query = {
      page: this.followingCurrentPage,
    };
    if (!this.isAdminView) {
      // await this.getUserSessionFavourite({ page: this.favouriteCurrentPage });
      
      await this.fetchProfileData({ query });
      await this.getUserUpcomingSessions({ query });
      // await this.getCategoriesList();
      await this.getLanguagesList();
      this.personal_details = this.userProfile.personal_details;
      // this.category_id =
      //   this.personal_details.category_ids &&
      //   this.personal_details.category_ids.split(",") &&
      //   this.personal_details.category_ids.split(",")[0];
      this.followingTotalPages = this.userProfile.following.last_page;
      // await this.getCategoriesData(
      //   this.personal_details && this.personal_details.category_ids,
      //   this.personal_details && this.personal_details.category_name
      // );

      //Payment enable disbale API's
      this.getCheckPaymentEnableOrDisable();
      await this.checkPaymentEnableOrDisable;
      this.checkPaymentEnableOrDisable.forEach((element) => {
        //if value == 0 then payment is disable if value == 1 then payment is enabled
        if (element.key === "payment") {
          if (element.value === "0") this.paymentEnableDisable = "";
          else this.paymentEnableDisable = element.value;
        }
      });
    } else {
      await this.fetchProfileData({ query });
      this.currentComponent = 'AdminProfileLayout'
    }
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 6px;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.transition-fastest {
  transition-duration: 75ms;
}
.transition-faster {
  transition-duration: 100ms;
}
.transition-fast {
  transition-duration: 150ms;
}
.transition-medium {
  transition-duration: 200ms;
}
.transition-slow {
  transition-duration: 300ms;
}
.transition-slower {
  transition-duration: 500ms;
}
.transition-slowest {
  transition-duration: 700ms;
}
.transition-all {
  transition-property: all;
}
.transition-opacity {
  transition-property: opacity;
}
.transition-transform {
  transition-property: transform;
}
.focus-visible.focus-visible\:underline {
  text-decoration: underline;
}
</style>